import React from 'react';

import bentoEdit from '../../../assets/images/bento-edit.webp';
import iphone from '../../../assets/images/iphone-resto.webp';
import stats from '../../../assets/images/stats.webp';

export const LoginBento: React.FC = () => {
  return (
    <div className="grid gap-4 mt-10 grid-rows-2 max-h-[600px] overflow-auto">
      <div className="relative lg:row-span-2 h-full">
        <div className="relative bg-white flex h-full flex-col overflow-hidden rounded-[calc(theme(borderRadius.lg)+1px)] lg:rounded-l-[calc(2rem+1px)]">
          <div className="px-8 pb-3 pt-8 sm:px-10 sm:pb-0 sm:pt-10">
            <p className="mt-2 text-lg/7 font-medium tracking-tight text-gray-950 max-lg:text-center">Enregistrer votre restaurant</p>
            <p className="mt-2 max-w-lg text-sm/6 text-gray-600 max-lg:text-center">
              Remplissez un formulaire simple et rapide pour ajouter votre restaurant sur MonResto'Halal
            </p>
          </div>
          <div className="relative min-h-[30rem] max-w-sm mx-auto w-full grow [container-type:inline-size] max-lg:mx-auto max-lg:max-w-sm">
            <div className="absolute inset-x-10 bottom-0 top-10 overflow-hidden rounded-t-[12cqw] border-x-[3cqw] border-t-[3cqw] border-gray-700 bg-gray-900 shadow-2xl">
              <img className="size-full object-cover object-top" draggable={false} src={iphone} alt="" />
            </div>
          </div>
        </div>
        <div className="pointer-events-none absolute inset-px rounded-lg shadow ring-1 ring-black/5 lg:rounded-l-[2rem]" />
      </div>
      <div className="relative max-lg:row-start-1 h-full">
        <div className="absolute inset-px rounded-lg rounded-tr-[calc(2rem+1px)] bg-white max-lg:rounded-t-[2rem]" />
        <div className="relative flex h-full flex-col overflow-hidden rounded-[calc(theme(borderRadius.lg)+1px)] max-lg:rounded-t-[calc(2rem+1px)]">
          <div className="px-8 pt-8 sm:px-10 sm:pt-10">
            <p className="mt-2 text-lg/7 font-medium tracking-tight text-gray-950 max-lg:text-center">Modification de votre fiche</p>
            <p className="mt-2 max-w-lg text-sm/6 text-gray-600 max-lg:text-center">
              Éditez votre fiche restaurant pour la rendre plus attractive et attirer plus de clients
            </p>
          </div>

          <div className="flex flex-1 items-center [container-type:inline-size] max-lg:py-6 lg:pb-2">
            <img className="h-[min(152px,40cqw)] object-cover object-center" draggable={false} src={bentoEdit} alt="" />
          </div>
        </div>
        <div className="pointer-events-none absolute inset-px rounded-lg rounded-tr-[calc(2rem+1px)] shadow ring-1 ring-black/5 max-lg:rounded-t-[2rem]" />
      </div>
      <div className="relative max-lg:row-start-3 lg:col-start-2 h-full lg:row-start-2">
        <div className="absolute inset-px rounded-br-[calc(2rem+1px)] rounded-lg bg-white" />
        <div className="relative flex h-full flex-col overflow-hidden rounded-[calc(theme(borderRadius.lg)+1px)]">
          <div className="px-8 pt-8 sm:px-10 sm:pt-10">
            <p className="mt-2 text-lg/7 font-medium tracking-tight text-gray-950 max-lg:text-center">Stats des visites</p>
            <p className="mt-2 max-w-lg text-sm/6 text-gray-600 max-lg:text-center">
              Consultez les statistiques détaillées de votre fiche restaurant pour améliorer votre visibilité
            </p>
          </div>
          <div className="flex flex-1 items-center w-full max-lg:py-6 lg:pb-2">
            <img className="h-[min(152px,40cqw)] object-cover rounded-br-[calc(1.5rem)] object-center" draggable={false} src={stats} alt="" />
          </div>
        </div>
        <div className="pointer-events-none absolute inset-px rounded-lg rounded-br-[calc(2rem+1px)] shadow ring-1 ring-black/5" />
      </div>
    </div>
  );
};
